/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Open

1 = Ready For Payment

2 = Paid

3 = Void

4 = Under Sub/Vendor Review

5 = Online Payment Processing

6 = Online Payment Declined

7 = Online Payment Failed

8 = In Review

9 = Draft

-2 = Requested

-1 = N/A


 */
export type PurchaseOrderPaymentStatus =
  (typeof PurchaseOrderPaymentStatus)[keyof typeof PurchaseOrderPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseOrderPaymentStatus = {
  Open: 0,
  ReadyForPayment: 1,
  Paid: 2,
  Void: 3,
  UnderSubReview: 4,
  OnlinePaymentProcessing: 5,
  OnlinePaymentDeclined: 6,
  OnlinePaymentFailed: 7,
  InReview: 8,
  Draft: 9,
  Requested: -2,
  NotApplicable: -1,
} as const;
